import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import { RouterStateUrl } from './router.reducer';

const getRouterFeatureState = createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>('router');

export const getRouterUrl = createSelector(
  getRouterFeatureState,
  (state: fromRouter.RouterReducerState<RouterStateUrl>) => state && state.state && state.state.url,
);

export const getRouterParams = createSelector(
  getRouterFeatureState,
  (state: fromRouter.RouterReducerState<RouterStateUrl>) => state && state.state && state.state.params,
);

export const getRouterQueryParams = createSelector(
  getRouterFeatureState,
  (state: fromRouter.RouterReducerState<RouterStateUrl>) => state && state.state && state.state.queryParams,
);

export const getRouterSegments = createSelector(
  getRouterFeatureState,
  (state: fromRouter.RouterReducerState<RouterStateUrl>) => (state && state.state && state.state.segments) || [],
);
